import {Container} from 'pixi.js';
import {PlatformScaleParameters, ScaleParameters} from '@gongxigames/framework/slot';

export type MobileReelsScaleParameters = {
    /**
     * @deprecated use portrait instead
     */
    reelsMobilePortraitModeParams: ScaleParameters;
    /**
     * @deprecated use landscape instead
     */
    reelsMobileLandscapeModeParams: ScaleParameters;
} & PlatformScaleParameters;

export interface IReelsScaleService {
    init(): void;
    reelsMobileLandscapeScale(container?: Container): void;
    reelsMobilePortraitScale(container?: Container): void;
    reelsDesktopScale(container?: Container): void;
    scaleByCurrentScreenOrientation(...container: Container[]): void;
    getMobileReelsParameters(): ScaleParameters;
    getMobileAllScaleParameters(): MobileReelsScaleParameters;
}
